import { render, staticRenderFns } from "./Actionnaire.vue?vue&type=template&id=54fcfe79"
import script from "./Actionnaire.vue?vue&type=script&lang=js"
export * from "./Actionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports